import React from 'react';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'


// display the time in the format HH:MM:SS
class Time extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        time: new Date(),
        };
    }

    componentDidMount() {
        this.timerID = setInterval(
            () => this.tick(),
            1000
        );
        }
    
    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        this.setState({
            time: new Date()
        });
    }

    render() {
        return (
                <Container style = {{display: 'flex', justifyContent: 'center'}}>
                    <Row>
                        <Col><h1 >{this.state.time.toLocaleTimeString()}</h1></Col>
                    </Row>
                </Container>
        );
    }
}

export default Time;